import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ProjectCard = ({ project, isCreateCard = false, onClickOverride }) => {
  const navigate = useNavigate();

  if (isCreateCard) {
    return (
      <div
        onClick={() => navigate('/project-creation')}
        className="group relative bg-card rounded-lg shadow-gaming-md overflow-hidden cursor-pointer transition-gaming hover:shadow-gaming-lg active:translate-y-px active:shadow-gaming-sm border-2 border-dashed border-primary/50"
        style={{ minHeight: '320px' }}
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/30 rounded-full flex items-center justify-center mb-4 transition-gaming">
            <Icon name="Plus" size={32} color="var(--color-primary)" />
          </div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
            새 목표 만들기
          </h3>
          <p className="text-sm text-muted-foreground caption">
            새로운 챌린지를 시작하세요
          </p>
        </div>
      </div>
    );
  }

  const averageStars = Number(project?.averageStars ?? 0);
  const roundedStars = Math.round(averageStars);

  return (
    <div
      onClick={() => (onClickOverride ? onClickOverride(project) : navigate(`/project-detail?id=${project?.id}`))}
      className="group relative bg-card rounded-lg shadow-gaming-md overflow-hidden cursor-pointer transition-gaming hover:shadow-gaming-lg active:translate-y-px active:shadow-gaming-sm"
      style={{ minHeight: '320px' }}
    >
      <div className="relative h-[180px] md:h-[190px] overflow-hidden">
        <div className="w-full h-full">
          <Image
            src={project?.coverImage}
            alt={project?.coverImageAlt}
            className="w-full h-full object-cover transition-gaming"
          />
        </div>
        <div className="absolute inset-0 bg-background/20" />
        
        {project?.isArchived && (
          <div className="absolute top-3 right-3 px-3 py-1 bg-muted/90 backdrop-blur-sm rounded-md flex items-center space-x-1">
            <Icon name="Archive" size={14} color="var(--color-muted-foreground)" />
            <span className="text-xs font-medium text-muted-foreground caption">보관됨</span>
          </div>
        )}
      </div>
      <div className="p-4 md:p-6 space-y-4">
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2 line-clamp-2">
            {project?.title}
          </h3>
          <p className="text-sm text-muted-foreground caption line-clamp-2">
            {project?.description}
          </p>
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground caption">챌린지 등록</span>
            <span className="font-medium text-foreground data-text">
              {project?.totalChallenges}
            </span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground caption">인증 등록</span>
            <span className="font-medium text-foreground data-text">
              {project?.completedProofs}
            </span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground caption">좋아요</span>
            <span className="font-medium text-foreground data-text">
              {project?.totalLikes ?? 0}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between pt-2 border-t border-border">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-1">
              <Icon name="Target" size={16} color="var(--color-primary)" />
              <span className="text-sm font-medium text-foreground data-text">
                {project?.totalChallenges}
              </span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="CheckCircle" size={16} color="var(--color-success)" />
              <span className="text-sm font-medium text-foreground data-text">
                {project?.completedProofs}
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            {[...Array(5)]?.map((_, index) => (
              <Icon
                key={index}
                name="Star"
                size={14}
                color="currentColor"
                className={index < roundedStars ? 'fill-current text-primary' : 'text-muted-foreground'}
              />
            ))}
            <span className="text-xs font-medium text-muted-foreground caption">
              {Number.isFinite(averageStars) ? averageStars.toFixed(1) : '0.0'}
            </span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ProjectCard;